var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgMenu = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 32,
  height: 32,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M4 4v2h24V4H4Zm0 10v2h24v-2H4Zm0 10v2h24v-2H4Z",
  fill: "#fff"
})));
export default SvgMenu;